export default function CurrencyIcon({ size = 'w-5 h-5', color = '#181D27' }) {
  return (
    <svg
      className={size}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Back card (shadow/virtual effect) */}
      <rect
        x="4.5"
        y="4.5"
        width="13"
        height="9"
        rx="1.5"
        stroke={color}
        strokeOpacity="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Front card */}
      <rect
        x="2.5"
        y="6.5"
        width="13"
        height="9"
        rx="1.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Card stripe */}
      <path d="M2.5 9.5H15.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      {/* Virtual dots indicator */}
      <circle cx="5" cy="13" r="0.4" fill={color} />
      <circle cx="6.5" cy="13" r="0.4" fill={color} />
      <circle cx="8" cy="13" r="0.4" fill={color} />
      <circle cx="9.5" cy="13" r="0.4" fill={color} />
      {/* Account number */}
      <path d="M5 11.5H12" stroke={color} strokeWidth="0.7" strokeLinecap="round" />
    </svg>
  );
}
